export { Zoom };
window.Zoom = Zoom;
function Zoom(ev) {
   let img = $(ev.target),
      doc = $(document),
      container = $('#stepsContainer'),
      zoomImgFrame = container.find('.zoom-img').first(),
      zoomImg = $(new Image()),
      padding = 20; // Padding around zoomed-in image (also in steps.less)

   zoomImg.load(function () {
      container.addClass('img-zoomed-in');
      zoomImgFrame.html(zoomImg);
      startZoomIn();
   });

   zoomImg.attr({
      'data-zoom': 'out',
      srcset: img.attr('srcset'),
      src: img.attr('data-zoom-url'),
   });

   function startZoomIn() {
      setTransform();
      zoomImg.position(); // Force repaint before setting a transition
      zoomImg.addClass('animate-zoom zoom-in');

      setZoomOutEvents();
   }

   function setTransform() {
      let transformCSS = calcDelta(getDeltaPoint(img), getDeltaPoint(zoomImg, padding));

      zoomImg.css({
         transform: transformCSS,
      });
   }

   function getDeltaPoint(img, padding) {
      let imgOffset = img.offset();
      padding = padding || 0;

      return {
         width: img.width(),
         height: img.height(),
         top: imgOffset.top + padding,
         left: imgOffset.left + padding,
      };
   }

   function calcDelta(from, to) {
      let zoomRatio = from.width / to.width,
         zoomRatioDimensionDiffX = (to.width * (1 - zoomRatio)) / 2,
         zoomRatioDimensionDiffY = (to.height * (1 - zoomRatio)) / 2,
         scaleCSS = 'scale(' + from.width / to.width + ')',
         translateXCSS = (from.left - to.left - zoomRatioDimensionDiffX) / zoomRatio + 'px',
         translateYCSS = (from.top - to.top - zoomRatioDimensionDiffY) / zoomRatio + 'px',
         transformCSS = scaleCSS + ' translate(' + translateXCSS + ', ' + translateYCSS + ')';

      return transformCSS;
   }

   function setZoomOutEvents() {
      doc.on('keydown click', zoomOut);
   }

   function destroyZoomOutEvents() {
      doc.off('keydown click', zoomOut);
   }

   function zoomOut(ev) {
      setTransform();
      container.addClass('img-zoom-closing');
      zoomImg.removeClass('zoom-in');
      zoomImg.on('transitionend', removeZoomState);
      setTimeout(removeZoomState, 200);
      destroyZoomOutEvents();
   }

   function removeZoomState() {
      container.removeClass('img-zoomed-in img-zoom-closing');
      zoomImg.remove();
   }
}
